// extracted by mini-css-extract-plugin
module.exports = {"s1fju4i7":"s1fju4i7","sm6ufe5":"sm6ufe5"};